import * as $ from 'jquery';
import * as app from 'CMS/core/application';
import { BaseRepository } from 'visuris/Data/Repositories/BaseRepository';
import ActionResult from 'visuris/Data/DTOs/ActionResult';
import FavoriteLocations from 'visuris/Data/Entities/FavoriteLocations';

export default class FavoriteLocationsRepository extends BaseRepository<FavoriteLocations> {

    // See constructor
    private GETFAVORITELOCATIONS = "";
    private REMOVEFAVORITELOCATION = "";
    private ADDLOCATIONTOFAVORITE = "";
    private INCREMENTFAVORITELOCATIONSCORE = "";

    constructor() {
        super();
        this.GETFAVORITELOCATIONS = app.formatLocationUrl("~/visuris/api/Favorites/Locations/GetAllFavoriteLocations");
        this.REMOVEFAVORITELOCATION = app.formatLocationUrl("~/visuris/api/Favorites/Locations/RemoveFavoriteLocation");
        this.ADDLOCATIONTOFAVORITE = app.formatLocationUrl('~/visuris/api/Favorites/Locations/AddLocationToFavorite?isrs=');
        this.INCREMENTFAVORITELOCATIONSCORE = app.formatLocationUrl('~/visuris/api/Favorites/Locations/IncrementFavoriteLocationScore?isrs=');
    }

    public list(): Promise<FavoriteLocations[]> {
        return new Promise<FavoriteLocations[]>((resolve, reject) => {
            var $get = $.get(this.GETFAVORITELOCATIONS);
            $get.then((data) => {                
                var favoriteLocations: FavoriteLocations[] = []; 
                for(let i = 0; i < data.length; i++) {
                    var item = data[i];                    
                    favoriteLocations.push(FavoriteLocationsRepository.fromDTO(item));
                }
                resolve(favoriteLocations);
            }, () => {
                reject();
            });
        });
    }
    public get(id: string): Promise<FavoriteLocations> {
        return null;
    }

    public getFavoriteLocations(): Promise<FavoriteLocations> {
        return new Promise<FavoriteLocations>((resolve, reject) => {
            var $get = $.get(this.GETFAVORITELOCATIONS);
            $get.then((data) => {
                resolve(FavoriteLocationsRepository.fromDTO(data));
            }, () => {
                reject();
            });
        });
    }
    public remove(isrs: string): Promise<boolean> {
        return new Promise<boolean>((resolve, reject) => {
            var $post = $.post({ url: this.REMOVEFAVORITELOCATION, data: JSON.stringify(isrs), contentType: 'application/json' });
            $post.then((data) => {
                resolve(true);
            }, () => {
                reject();
            });
        });
    }

    public addFavoriteLocation(isrs: string): Promise<ActionResult> {
        return new Promise<ActionResult>((resolve, reject) => {
            const $post = $.post(this.ADDLOCATIONTOFAVORITE + isrs);
            $post.then((data) => {
                resolve(data);
            }, (error) => {
                reject(error);
            });
        });
    }

    public incrementFavoriteLocationScore(isrs: string): Promise<ActionResult> {
        return new Promise<ActionResult>((resolve, reject) => {
            const $post = $.post(this.INCREMENTFAVORITELOCATIONSCORE + isrs);
            $post.then((data) => {
                resolve(data);
            }, (error) => {
                reject(error);
            });
        });
    }

    public static fromDTO(item: any): FavoriteLocations {
        var favloc = new FavoriteLocations();
        favloc.locations = item.locations;
        favloc.fairWayName = item.fairWayName;
        return favloc;
    }
}

